import { render, staticRenderFns } from "./input-outline2.vue?vue&type=template&id=08b7f149&scoped=true&"
var script = {}
import style0 from "./input-outline2.vue?vue&type=style&index=0&id=08b7f149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7f149",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b7f149')) {
      api.createRecord('08b7f149', component.options)
    } else {
      api.reload('08b7f149', component.options)
    }
    module.hot.accept("./input-outline2.vue?vue&type=template&id=08b7f149&scoped=true&", function () {
      api.rerender('08b7f149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/input-outline2.vue"
export default component.exports